export const getCurrentDate = (addTime: boolean = false) => {
  const today = new Date();
  let month: number | string = today.getMonth() + 1;
  let day: number | string = today.getDate();

  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;

  let finalDate = [today.getFullYear(), month, day].join("-");

  if (addTime) {
    let hour: number | string = today.getHours();
    let minutes: number | string = today.getMinutes();
    let seconds: number | string = today.getSeconds();

    hour = hour < 10 ? "0" + hour : hour;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    finalDate += " " + [hour, minutes, seconds].join(":");
  }

  return finalDate;
};

export const getDaysOfMonth = ({
  year,
  month,
}: {
  year: number;
  month: number;
}) => {
  try {
    return {
      days: new Date(year, month, 0).getDate(),
      lastDays: new Date(year, month - 1, 0).getDate(),
      dayWeek: new Date(year, month - 1, 1).getDay(),
    };
  } catch (error) {
    console.log("getDaysOfMonth error: ", error);
  }
  return false;
};
